<h2>Modifier plusieurs opérations</h2>
<div class="wrapper">
  <form>

    <div class="form-row mt-3">
      <mat-checkbox (change)="onChangeCheckboxSelection('minimum_delay')" class="ml-2 mr-1 mt-4" [checked]="updateValues.minimum_delay"></mat-checkbox>
      <div class="form-group col-md-3">
        <label for="minimum_delay">Délai minimum :</label>
        <input [(ngModel)]="operation.minimum_delay"  class="form-control" id="minimum_delay" name="minimum_delay">
      </div>
    </div>
    <div class="form-row mt-3">
      <mat-checkbox (change)="onChangeCheckboxSelection('actif')" class="ml-2 mr-1 mt-1" [checked]="updateValues.actif"></mat-checkbox>
      <div class="form-group col-md-3 d-flex align-items-center">
        <label>Actif :</label>
        <mat-checkbox (change)="onChangeCheckbox('actif')" class="ml-2" [checked]="operation.actif"></mat-checkbox>
      </div>
    </div>
    <div class="form-row mt-3">
      <mat-checkbox (change)="onChangeCheckboxSelection('blocked')" class="ml-2 mr-1 mt-1" [checked]="updateValues.blocked"></mat-checkbox>
      <div class="form-group col-md-3 d-flex align-items-center">
        <label>Opération bloquante :</label>
        <mat-checkbox (change)="onChangeCheckbox('blocked')" class="ml-2" [checked]="operation.blocked"></mat-checkbox>
      </div>
    </div>

    <div class="btn-group mt-3 mb-5">
      <div>
        <button (click)="onClickMassUpdate()" class="btn btn100px btn-dark p-2 mr-2">Modifier</button>
      </div>

      <div>
        <button (click)="onCancelClik()" class="btn btn-light btn100px border-dark p-2">Annuler</button>
      </div>
    </div>
  </form>
</div>
